<template>
    <footer>
        <h2 class="sr-only">{{ $t('footer.header') }}</h2>
        <div class="columns">
            <section>
                <h3 class="footerHeader">{{ $t('labels.about') }}</h3>
                <p class="footerBody">
                    {{ $t('footer.disclaimer_1') }}
                </p>
                <img class="museumLogo" :alt="$t('footer.disclaimer_6_link_text')" :src="`${$rootUrl()}/images/HR_FCWM.png`" />
                <p class="footerBody">
                    {{ $t('footer.disclaimer_6') }}
                    <a class="footerBody" :href="$t('footer.disclaimer_6_link')" target="_blank">{{ $t('footer.disclaimer_6_link_text') }}</a>
                </p>
            </section>

            <section>
                <h3 class="footerHeader">{{ $t('labels.useful_links') }}</h3>
                <ul class="link-list">
                    <li><a class="footerBody" :href="$t('footer.disclaimer_2_link')" target="_blank">{{ $t('footer.disclaimer_2') }}</a></li>
                    <li><a class="footerBody" :href="$t('footer.disclaimer_3_link')" target="_blank">{{ $t('footer.disclaimer_3') }}</a></li>
                    <li><a class="footerBody" :href="$t('footer.disclaimer_4_link')" target="_blank">{{ $t('footer.disclaimer_4') }}</a></li>
                    <li><a class="footerBody" :href="$t('footer.disclaimer_5_link')" target="_blank">{{ $t('footer.disclaimer_5') }}</a></li>
                    <li><a class="footerBody" :href="$t('footer.disclaimer_7_link')">{{ $t('footer.disclaimer_7') }}</a></li>
                </ul>
            </section>
            <div class="logo-social">
                <section>
                    <h2 class="footerTagline">{{ $t('footer.tagline_1') }} {{ $t('footer.tagline_2') }} {{ $t('footer.tagline_3') }}</h2>
                </section>
                <section>
                    <ul class="link-list social">
                        <li>
                            <a class="footerBody facebook-link" :href="$t('footer.facebook_link')" target="_blank">
                                <span class="sr-only">{{ $t('footer.facebook_link_label') }}</span>
                            </a>
                        </li>
                        <li>
                            <a class="footerBody twitter-link" :href="$t('footer.twitter_link')" target="_blank">
                                <span class="sr-only">{{ $t('footer.twitter_link_label') }}</span>
                            </a>
                        </li>
                        <li>
                            <a class="footerBody instagram-link" :href="$t('footer.instagram_link')" target="_blank">
                                <span class="sr-only">{{ $t('footer.instagram_link_label') }}</span>
                            </a>
                        </li>
                    </ul>
                </section>
                <section class="links">
                    <img class="footerLogo" :alt="$t('footer.canada_gov_alt')" :src="`${$rootUrl()}${$t('footer.canada_gov_img')}`" />
                    <ul class="link-list">
                        <li><a class="footerBody" :href="$t('footer.privacy_statement_link')" target="_blank">{{ $t('labels.privacy_statement') }}</a></li>
                        <li><a class="footerBody" :href="$t('footer.copyright_link')" target="_blank">{{ $t('labels.copyright') }}</a></li>
                        <li><span style="font-size: 12px;" class="footerBody">{{ $t('labels.museum_name') }} </span></li>
                    </ul>
                </section>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer"
}
</script>

<style scoped lang="scss">

footer {
    /* otherwise white border appears */
    border: #111315 1px solid;
    background-color: #111315;
    display: flex;
    justify-content: space-between;
}

footer a{
    color: #ffffff;
    &:hover {
        color: #92b2cf;
        text-decoration: underline;
    }
}

.footerBody {
    font-size: 14px;
    line-height: 24px;
    color: #ffffff;
    font-weight: normal;
}

.footerHeader {
    color: #ffffff;
    font-family: "FuturaBold";
    font-size: 13px;
    line-height: 24px;
    text-decoration: none;
    text-transform: uppercase;
}

.footerTagline {
    font-family: "FuturaBold";
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 2px;
    text-decoration: none;
    text-transform: uppercase;
    color: #edece8;
}

.columns {
  overflow: auto;
  display: flex;
  margin: 20px;
  width: 100%;
  justify-content: space-between;

  > section {
      max-width: 400px;
  }
}

section {
    margin: 20px;
}

.museumLogo {
    margin-top: 30px;
    width: 168px;
    height: 42px;
}

.footerLogo {
    width: 100px;
    height: 70px;
}

.links {
    padding: 20px;
    padding-left: 0;
    text-align: right;
}


.link-list {
    padding: 0;
    margin: 0;
    list-style: none;
}

.link-list li {
    margin-bottom: 10px;
}

.logo-social {
    margin: 20px;
    max-width: 400px;
}

.logo-social .link-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.logo-social .link-list.social {
    width: 150px;
}

.logo-social .link-list a {
    text-decoration: none;
    padding-right: 5px;
    font-size: 12px;
}

.logo-social .link-list a:hover {
    text-decoration: underline;
}

.facebook-link:after {
    content: url('../assets/icons/facebook-white.svg');
    width: 25px;
    height: 25px;
}
.facebook-link:hover:after {
    content: url('../assets/icons/facebook.svg');
    border-bottom: solid 1px white;
}

.twitter-link:after {
    content: url('../assets/icons/twitter-white.svg');
    width: 25px;
    height: 25px;
}
.twitter-link:hover:after {
    content: url('../assets/icons/twitter.svg');
    border-bottom: solid 1px white;
}

.instagram-link:after {
    content: url('../assets/icons/instagram-white.svg');
    width: 25px;
    height: 25px;
}
.instagram-link:hover:after {
    content: url('../assets/icons/instagram.svg');
    border-bottom: solid 1px white;
}

@media screen and (max-width: 900px) {
    footer {
        flex-wrap: wrap;
        justify-content: flex-end;
    }
    .columns {
        width: 100%;
        flex-direction: column;
    }

    .logo-social {
        align-self: flex-end;
    }
}

@media screen and (max-width: 400px) {
    footer {
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .columns section {
        width: 100%;
        margin: 15px 0;
    }

    .logo-social {
        align-self: flex-start;
        margin: 0;

        section.links {
            padding: 0;
        }
    }
}
</style>
